module.exports = __webpack_public_path__ + "static/media/state3.2e1edb1a.svg";